<script setup>
import { ref, nextTick } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import EmojiInput from 'shared/components/emoji/EmojiInput.vue';

const emit = defineEmits(['select', 'close']);

// eslint-disable-next-line @intlify/vue-i18n/no-raw-text
const QUICK_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

const showFullPicker = ref(false);
// eslint-disable-next-line @intlify/vue-i18n/no-raw-text
const EXPAND_ICON = '+';
const pickerStyle = ref({});
const expandBtnRef = ref(null);

// Clicar fora fechava o menu de emoji rápido mas nunca o picker inteiro —
// não existia handler nenhum pra isso (achado 2026-07-15, pedido do Victor).
function handleClickOutside() {
  showFullPicker.value = false;
  emit('close');
}

function selectEmoji(emoji) {
  emit('select', emoji);
  showFullPicker.value = false;
}

function handleEmojiClick(emoji) {
  selectEmoji(emoji);
}

async function toggleFullPicker() {
  if (showFullPicker.value) {
    showFullPicker.value = false;
    return;
  }
  showFullPicker.value = true;
  await nextTick();
  if (expandBtnRef.value) {
    const rect = expandBtnRef.value.getBoundingClientRect();
    const pickerWidth = 350;
    const pickerHeight = 400;
    let left = rect.left;
    let top = rect.top - pickerHeight - 8;

    // Keep within viewport horizontally
    if (left + pickerWidth > window.innerWidth) {
      left = window.innerWidth - pickerWidth - 8;
    }
    if (left < 8) left = 8;

    // If no room above, show below
    if (top < 8) {
      top = rect.bottom + 8;
    }

    pickerStyle.value = {
      position: 'fixed',
      left: `${left}px`,
      top: `${top}px`,
      zIndex: 9999,
    };
  }
}
</script>

<template>
  <div v-on-click-outside="handleClickOutside" class="relative">
    <!-- A barra de emojis nasce do botão que a abriu (24/10/2026, `.advup-pop`). -->
    <div
      class="flex items-center gap-0.5 px-1.5 py-1 rounded-full bg-n-background shadow-md border border-n-weak advup-pop"
    >
      <button
        v-for="emoji in QUICK_EMOJIS"
        :key="emoji"
        class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-n-alpha-2 transition-transform hover:scale-125 cursor-pointer text-base"
        @click="selectEmoji(emoji)"
      >
        {{ emoji }}
      </button>
      <button
        ref="expandBtnRef"
        class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-n-alpha-2 transition-colors cursor-pointer text-sm text-n-slate-11"
        @click="toggleFullPicker"
      >
        {{ EXPAND_ICON }}
      </button>
    </div>
    <Teleport to="body">
      <div
        v-if="showFullPicker"
        class="fixed inset-0 z-[9998]"
        @click="showFullPicker = false"
      />
      <div v-if="showFullPicker" :style="pickerStyle">
        <EmojiInput :on-click="handleEmojiClick" />
      </div>
    </Teleport>
  </div>
</template>
